export class Category {
  constructor({ id, labels, icon }) {
    this.id = id;
    this.labels = labels;
    this.icon = icon;
  }

  getLabel(language = 'fr') {
    return this.labels?.[language] || this.labels?.['en'] || this.id;
  }
} 